<template>
  <div>
    <!-- start: page -->
    <form class="ecommerce-form action-buttons-fixed" @submit.prevent="submitForm">
      <div class="row">
        <div class="col">
          <section class="card card-modern card-big-info">
            <div class="card-body">
              <div class="row">
                <div class="col-lg-2-5 col-xl-1-5">
                  <i class="card-big-info-icon bx bx-slider"></i>
                  <h2 class="card-big-info-title">{{ translations.details }}</h2>
                  <p class="card-big-info-desc">
                    {{ translations.detailsInfo }}
                  </p>
                </div>

                <div class="col-lg-3-5 col-xl-4-5">


                  <div class="form-group row align-items-center mb-3"
                  :class="{ 'has-danger': $v.mainForm.title.$anyError }">
                    <label class="col-lg-5 col-xl-3 control-label text-lg-end mb-0">Naziv</label>
                    <div class="col-lg-7 col-xl-6">
                      <input
                        type="text"
                        class="form-control form-control-modern"
                        placeholder="Naziv"
                        v-model="mainForm.title"
                      />

                      <form-error
                        :model="$v.mainForm.title"
                        label="Naziv"
                        :dirty="$v.mainForm.$dirty"
                      />
                    </div>
                  </div>

                  <div class="form-group row align-items-center mb-3">
                    <label class="col-lg-5 col-xl-3 control-label text-lg-end mb-0">B2B/B2C</label>
                    <div class="col-lg-7 col-xl-6">
                      <treeselect
                        v-model="mainForm.businessType"
                        :options="b2bOrb2cOptions"
                        :disabled="true"
                      />
                    </div>
                  </div>

                  <div class="form-group row align-items-center mb-3">
                    <label class="col-lg-5 col-xl-3 control-label text-lg-end mb-0">Tip popusta</label>
                    <div class="col-lg-7 col-xl-6">
                      <treeselect
                        v-model="mainForm.discountApplianceType"
                        :options="discountTypes"
                        :disabled="true"
                      />
                    </div>
                  </div>

                  <div class="form-group row align-items-center mb-3"
                  :class="{ 'has-danger': $v.mainForm.code.$anyError }">
                    <label class="col-lg-5 col-xl-3 control-label text-lg-end mb-0">Promo kod</label>
                    <div class="col-lg-7 col-xl-6">
                      <div class="d-flex">
                        <input
                          type="text"
                          class="form-control form-control-modern"
                          placeholder="Promo kod"
                          v-model="mainForm.code"
                        />
                        <button
                          type="button"
                          class="btn btn-primary ms-1"
                          @click="generateCode()"
                        >
                          Generiraj
                        </button>
                      </div>
                      <form-error
                        :model="$v.mainForm.code"
                        label="Poklon kod"
                        :dirty="$v.mainForm.$dirty"
                      />
                    </div>
                  </div>

                  <div class="form-group row align-items-center mb-3"
                  :class="{ 'has-danger': $v.mainForm.limitationUsageNumber.$anyError }">
                    <label class="col-lg-5 col-xl-3 control-label text-lg-end mb-0">Limit upotrebe</label>
                    <div class="col-lg-7 col-xl-6">
                      <input
                        type="text"
                        class="form-control form-control-modern"
                        placeholder="Limit upotrebe"
                        v-model.number="mainForm.limitationUsageNumber"
                      />

                      <form-error
                        :model="$v.mainForm.limitationUsageNumber"
                        label="Limit upotrebe"
                        :dirty="$v.mainForm.$dirty"
                      />
                    </div>
                  </div>

                  <div class="form-group row align-items-center mb-3"
                  :class="{ 'has-danger': $v.mainForm.discount.$anyError }">
                    <label class="col-lg-5 col-xl-3 control-label text-lg-end mb-0">Iznos popusta</label>
                    <div class="col-lg-7 col-xl-6">
                      <input
                        type="text"
                        class="form-control form-control-modern"
                        placeholder="Iznos popusta"
                        v-model.number="mainForm.discount"
                      />

                      <form-error
                        :model="$v.mainForm.discount"
                        label="Iznos popusta"
                        :dirty="$v.mainForm.$dirty"
                      />
                    </div>
                  </div>

                  <div class="form-group row align-items-center mb-3"
                  :class="{ 'has-danger': $v.mainForm.startDate.$anyError }">
                    <label class="col-lg-5 col-xl-3 control-label text-lg-end mb-0">Vrijedi od</label>
                    <div class="col-lg-7 col-xl-6">
                      <date-picker
                        type="datetime"
                        placeholder="Vrijedi od"
                        v-model="mainForm.startDate"
                        input-class="form-control form-control-modern bg-body"
                        class="date-picker-width"
                        format="DD.MM.YYYY HH:mm"
                        :lang="options"
                      ></date-picker>

                      <form-error
                        :model="$v.mainForm.startDate"
                        label="Vrijedi od"
                        :dirty="$v.mainForm.$dirty"
                      />
                    </div>
                  </div>

                  <div class="form-group row align-items-center mb-3"
                  :class="{ 'has-danger': $v.mainForm.endDate.$anyError }">
                    <label class="col-lg-5 col-xl-3 control-label text-lg-end mb-0">Vrijedi do</label>
                    <div class="col-lg-7 col-xl-6">
                      <date-picker
                        type="datetime"
                        placeholder="Kraj"
                        v-model="mainForm.endDate"
                        input-class="form-control form-control-modern bg-body"
                        class="date-picker-width"
                        format="DD.MM.YYYY HH:mm"
                        :lang="options"
                      ></date-picker>

                      <form-error
                        :model="$v.mainForm.endDate"
                        label="Vrijedi do"
                        :dirty="$v.mainForm.$dirty"
                      />
                    </div>
                  </div>

                </div>

              </div>
            </div>
          </section>
        </div>
      </div>
      <div class="row mt-3" v-if="mainForm.discountApplianceType !== 1">
        <div class="col">
          <section class="card card-modern card-big-info">
            <div class="card-body">
              <div class="row">
                <div class="col-lg-2-5 col-xl-1-5">
                  <i class="card-big-info-icon bx bx-slider"></i>
                  <h2 class="card-big-info-title">{{ translations.details }}</h2>
                  <p class="card-big-info-desc">
                    {{ translations.detailsInfo }}
                  </p>
                </div>

                <!-- proizvodi -->
                <div v-if="mainForm.discountApplianceType == 2" class="col-9 position-relative">
                  <div class="form-group row align-items-center">
                    <div class="col">
                      <div class="form-group row pb-3">
                        <label
                          class="col-lg-5 col-xl-3 control-label text-lg-end mb-0 mt-2"
                          >Pretraga artikala</label
                        >
                        <div class="col-lg-7 col-xl-6 pb-4 position-relative">
                          <input
                            type="text"
                            class="search-term form-control"
                            placeholder="Pretraga"
                            v-model="searchField"
                            @input="onSearchHandle('getArticles')"
                            @blur="onBlurHandle"
                          />

                          <ul
                            class="article-list bg-body"
                            v-if="showSearchResults"
                          >
                            <li
                              v-for="article in articles"
                              :key="article.id"
                              @click="addArticle(article)"
                            >
                              <div>
                                {{ article.title }}
                              </div>
                              <div>
                              Šifra: {{ article.code }}
                              </div>
                              <div v-if="mainForm.businessType == 1">
                                VPC: {{ article.vpc.toFixed(2).toString().replace('.', ',') }}
                              </div>
                              <div v-if="mainForm.businessType == 2">
                                MPC: {{ article.mpc.toFixed(2).toString().replace('.', ',') }}
                              </div>
                            </li>
                          </ul>
                        </div>

                        <div
                          class="dataTables_wrapper dt-bootstrap5 no-footer"
                          v-if="
                            promoCode.articles &&
                            promoCode.articles.length > 0
                          "
                        >
                          <div class="table-responsive">
                            <table
                              class="table table-ecommerce-simple table-striped mb-0 dataTable no-footer"
                            >
                              <thead>
                                <tr role="row">
                                  <th class="sorting">Rbr</th>
                                  <th class="sorting">Naziv</th>
                                  <th class="sorting">Šifra</th>
                                  <th class="sorting">Redovna cijena</th>
                                  <th></th>
                                </tr>
                              </thead>
                              <tbody>
                                <tr
                                  role="row"
                                  v-for="(
                                    item, index
                                  ) in promoCode.articles"
                                  :key="item.articleId"
                                  :class="{
                                    odd: index % 2 === 0,
                                    even: index % 2 !== 0,
                                  }"
                                >
                                  <td>
                                    <strong>{{ index + 1 }}</strong>
                                  </td>
                                  <td>
                                    <strong>{{ item.title }}</strong>
                                  </td>
                                  <td>
                                    <strong>{{ item.code }}</strong>
                                  </td>
                                  <td v-if="mainForm.businessType == 1">
                                    <strong>{{ item.vpc.toFixed(2).toString().replace('.', ',') }}</strong>
                                  </td>
                                  <td v-if="mainForm.businessType == 2">
                                    <strong>{{ item.mpc.toFixed(2).toString().replace('.', ',') }}</strong>
                                  </td>
                                  <td>
                                    <button
                                      type="button"
                                      class="btn"
                                      @click="deleteArticle(item)"
                                    >
                                      <i class="bx bx-trash text-4 me-2"></i>
                                    </button>
                                  </td>
                                </tr>
                              </tbody>
                            </table>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <!-- kategorije -->
                <div v-if="mainForm.discountApplianceType == 3" class="col-9 position-relative">
                  <div class="form-group row align-items-center">
                    <div class="col">
                      <div class="form-group row pb-3">
                        <label
                          class="col-lg-5 col-xl-3 control-label text-lg-end mb-0 mt-2"
                          >Pretraga kategorija</label
                        >
                        <div class="col-lg-7 col-xl-6 pb-4 position-relative">
                          <input
                            type="text"
                            class="search-term form-control"
                            placeholder="Pretraga"
                            v-model="searchField"
                            @input="onSearchHandle('getCategories')"
                            @blur="onBlurHandle"
                          />

                          <ul
                            class="article-list bg-body"
                            v-if="showSearchResults"
                          >
                            <li
                              v-for="item in categories"
                              :key="item.id"
                              @click="addCategory(item)"
                            >
                              <div>
                                {{ item.title }}
                              </div>
                             </li>
                          </ul>
                        </div>

                        <div
                          class="dataTables_wrapper dt-bootstrap5 no-footer"
                          v-if="
                            promoCode.categories &&
                            promoCode.categories.length > 0
                          "
                        >
                          <div class="table-responsive">
                            <table
                              class="table table-ecommerce-simple table-striped mb-0 dataTable no-footer"
                            >
                              <thead>
                                <tr role="row">
                                  <th class="sorting">Rbr</th>
                                  <th class="sorting">Naziv</th>
                                  <th></th>
                                </tr>
                              </thead>
                              <tbody>
                                <tr
                                  role="row"
                                  v-for="(
                                    item, index
                                  ) in promoCode.categories"
                                  :key="item.categoryId"
                                  :class="{
                                    odd: index % 2 === 0,
                                    even: index % 2 !== 0,
                                  }"
                                >
                                  <td>
                                    <strong>{{ index + 1 }}</strong>
                                  </td>
                                  <td>
                                    <strong>{{ item.title }}</strong>
                                  </td>
                                  <td>
                                    <button
                                      type="button"
                                      class="btn"
                                      @click="deleteCategory(item)"
                                    >
                                      <i class="bx bx-trash text-4 me-2"></i>
                                    </button>
                                  </td>
                                </tr>
                              </tbody>
                            </table>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <!-- brendovi -->
                <div v-if="mainForm.discountApplianceType == 4" class="col-9 position-relative">
                  <div class="form-group row align-items-center">
                    <div class="col">
                      <div class="form-group row pb-3">
                        <label
                          class="col-lg-5 col-xl-3 control-label text-lg-end mb-0 mt-2"
                          >Pretraga brendova</label
                        >
                        <div class="col-lg-7 col-xl-6 pb-4 position-relative">
                          <input
                            type="text"
                            class="search-term form-control"
                            placeholder="Pretraga"
                            v-model="searchField"
                            @input="onSearchHandle('getBrands')"
                            @blur="onBlurHandle"
                          />

                          <ul
                            class="article-list bg-body"
                            v-if="showSearchResults"
                          >
                            <li
                              v-for="item in brands"
                              :key="item.id"
                              @click="addBrand(item)"
                            >
                              <div>
                                {{ item.title }}
                              </div>
                             </li>
                          </ul>
                        </div>

                        <div
                          class="dataTables_wrapper dt-bootstrap5 no-footer"
                          v-if="
                            promoCode.brands &&
                            promoCode.brands.length > 0
                          "
                        >
                          <div class="table-responsive">
                            <table
                              class="table table-ecommerce-simple table-striped mb-0 dataTable no-footer"
                            >
                              <thead>
                                <tr role="row">
                                  <th class="sorting">Rbr</th>
                                  <th class="sorting">Naziv</th>
                                  <th></th>
                                </tr>
                              </thead>
                              <tbody>
                                <tr
                                  role="row"
                                  v-for="(
                                    item, index
                                  ) in promoCode.brands"
                                  :key="item.brandId"
                                  :class="{
                                    odd: index % 2 === 0,
                                    even: index % 2 !== 0,
                                  }"
                                >
                                  <td>
                                    <strong>{{ index + 1 }}</strong>
                                  </td>
                                  <td>
                                    <strong>{{ item.title }}</strong>
                                  </td>
                                  <td>
                                    <button
                                      type="button"
                                      class="btn"
                                      @click="deleteBrand(item)"
                                    >
                                      <i class="bx bx-trash text-4 me-2"></i>
                                    </button>
                                  </td>
                                </tr>
                              </tbody>
                            </table>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>


              </div>
            </div>
          </section>
        </div>
      </div>
      <div class="row action-buttons">
        <div class="col-12 px-md-0 mt-3 mt-md-0 d-flex justify-content-end gap-3">
          <router-link
            class="cancel-button btn btn-light btn-px-4 py-3 border font-weight-semibold text-color-dark text-3" exact
            :to="{ name: 'Coupons' }">
            {{ translations.cancel }}
          </router-link>
          <button type="submit"
            class="ubmit-button btn btn-primary btn-px-4 py-3 d-flex align-items-center font-weight-semibold line-height-1">
            <i class="bx bx-save text-4 me-2"></i> {{ translations.save }}
          </button>
        </div>
      </div>
    </form>
    <!-- ------------------------------------------------ -->
    <modal id="add-promo-code-modal" :closeModalAction="cancelPromoCode">
      <h5 slot="header">
        <strong>Dodaj promo kod</strong>
      </h5>
      <div slot="body">
        <form>
        <div
          class="form-group row align-items-center mb-3"
          :class="{ 'has-danger': $v.newPromoCodeFrom.title.$anyError }"
        >
          <label
            class="col-lg-5 col-xl-3 control-label text-lg-end mb-0"
            >Naziv</label
          >
          <div class="col-lg-7 col-xl-8">
            <input
              type="text"
              class="form-control form-control-modern"
              placeholder="Naziv"
              v-model="newPromoCodeFrom.title"
            />

            <form-error
              :model="$v.newPromoCodeFrom.title"
              label="Naziv"
              :dirty="$v.newPromoCodeFrom.$dirty"
            />
          </div>
        </div>

        <div
          class="form-group row align-items-center mb-3"
          :class="{ 'has-danger': $v.newPromoCodeFrom.businessType.$anyError }"
        >
          <label
            class="col-lg-5 col-xl-3 control-label text-lg-end mb-0"
            >B2B/B2C</label
          >
          <div class="col-lg-7 col-xl-8">
            <treeselect
            v-model="newPromoCodeFrom.businessType"
            class="w-100 custom-vue-tree-select"
            :options="b2bOrb2cOptions"
            placeholder="B2B/B2C"
          />

            <form-error
              :model="$v.newPromoCodeFrom.businessType"
              label="B2B/B2C"
              :dirty="$v.newPromoCodeFrom.$dirty"
            />
          </div>
        </div>

        <div
          class="form-group row align-items-center mb-3"
          :class="{ 'has-danger': $v.newPromoCodeFrom.discountApplianceType.$anyError }"
        >
          <label
            class="col-lg-5 col-xl-3 control-label text-lg-end mb-0"
            >Tip popusta</label
          >
          <div class="col-lg-7 col-xl-8">
            <treeselect
            v-model="newPromoCodeFrom.discountApplianceType"
            class="w-100 custom-vue-tree-select"
            :options="discountTypes"
            placeholder="Tip popusta"
          />

            <form-error
              :model="$v.newPromoCodeFrom.discountApplianceType"
              label="Tip popusta"
              :dirty="$v.newPromoCodeFrom.$dirty"
            />
          </div>
        </div>
      </form>
      </div>
      <div slot="footer">
        <div class="row">
          <div class="col-md-12 text-end">
            <button
              type="button"
              class="btn btn-primary px-4 mx-2"
              @click="submitModalForm"
            >
              {{ translations.next }}
            </button>
            <button
              type="button"
              class="btn btn-default px-4"
              data-bs-dismiss="modal"
              @click="cancelPromoCode"
            >
              {{ translations.cancel }}
            </button>
          </div>
        </div>
      </div>
    </modal>
    <!-- end: page -->
  </div>
</template>

<script>
import { uuid } from 'uuidv4';
import Treeselect from '@riophae/vue-treeselect';
import '@riophae/vue-treeselect/dist/vue-treeselect.css';

import { format } from "date-fns";
import { debounce } from 'lodash';
import DatePicker from 'vue2-datepicker';
import 'vue2-datepicker/index.css';
import bs from "vuejs-datepicker/dist/locale/translations/bs";
import modalValidations from "./validation-schema/add-modal";
import validations from "./validation-schema/add";
import FormError from "../shared/form-errors/FormError.vue";
import Modal from '../shared/modal/Modal.vue';

import { translations } from '@/mixins';
import api from '@/services/api';

export default {
  name: 'AddPromoCode',
  mixins: [translations],
  validations: {
    newPromoCodeFrom: modalValidations,
    mainForm: validations,
  },
  components: {
    DatePicker,
    Treeselect,
    FormError,
    Modal,
  },
  data() {
    return {
      newPromoCodeFrom: {
        title: null,
        businessType: null,
        discountApplianceType: null,
      },
      mainForm: {
        title: null,
        businessType: null,
        discountApplianceType: null,
        code: null,
        discount: null,
        startDate: null,
        endDate: null,
        limitationUsageNumber: null,
        discountApplianceTypeIds: [],
      },
      options: {
        formatLocale: {
          firstDayOfWeek: 1,
        },
      },
      searchField: '',
      showSearchResults: false,
      promoCode: {
        articles: [],
        categories: [],
        brands: []
      },
    };
  },
  mounted() {
    this.openAddModal();
  },
  computed: {
    bs() {
      return bs;
    },
    disabledDates() {
      const date = new Date();
      date.setDate(date.getDate() - 1);

      return {
        to: date,
      };
    },
    articles() {
      var data = this.$store.getters.getArticles;
      return data.filter((x) => !this.promoCode.articles.map((a) => a.articleId).includes(x.id));
    },
    categories() {
      var data = this.$store.getters.getCategories;
      return data.filter((x) => !this.promoCode.categories.map((a) => a.categoryId).includes(x.id));
    },
    brands() {
      var data = this.$store.getters.getBrands;
      return data.filter((x) => !this.promoCode.brands.map((a) => a.brandId).includes(x.id));
    },
    isModalFormValid() {
      return !this.$v.newPromoCodeFrom.$invalid;
    },
    isFormValid() {
      return !this.$v.mainForm.$invalid;
    },
    discountTypes() {
      return [
        {
        id: 1,
        label: 'Popust se odnosi na iznos narudžbe',
      }, {
        id: 2,
        label: 'Popust se odnosi na proizvode',
      }, {
        id: 3,
        label: 'Popust se odnosi na kategorije',
      }, {
        id: 4,
        label: 'Popust se odnosi na brand'
      }];
    },
    b2bOrb2cOptions() {
      return [
        { id: 1, label: 'B2B' },
        { id: 2, label: 'B2C' },
      ];
    },
  },
  methods: {
    generateCode() {
      const uuidV4 = uuid().split('-')[0];
      this.mainForm.code = `${uuidV4}-`;
    },
    customFormatter(date) {
      return format(date, "dd.MM.yyyy.");
    },
    submitForm() {
      this.$v.mainForm.$touch();
      if (!this.isFormValid) {
        this.$toast.error(this.translations.forms.notValid);
        return;
      }
      let {
        title,
        businessType,
        discountApplianceType,
        discountApplianceTypeIds,
        code,
        discount,
        startDate,
        endDate,
        limitationUsageNumber,
      } = this.mainForm;

      if(discountApplianceType == 4) {
        discountApplianceTypeIds = [];
        discountApplianceTypeIds = this.promoCode.brands.map(item => item.brandId);
      }
      else if(discountApplianceType == 3) {
        discountApplianceTypeIds = [];
        discountApplianceTypeIds = this.promoCode.categories.map(item => item.categoryId);
      }
      else if(discountApplianceType == 2) {
        discountApplianceTypeIds = [];
        discountApplianceTypeIds = this.promoCode.articles.map(item => item.articleId);
      }

      api.createPromoCode({
        title,
        businessType,
        discountApplianceType,
        discountApplianceTypeIds,
        code,
        discount,
        startDate,
        endDate,
        limitationUsageNumber,
      })
        .then((response) => {
          this.$toast.info(response.data.info);
          this.$router.push({ name: 'Coupons' });
        })
        .catch((err) => {
          this.$toast.error(err?.response?.data?.info || 'Desila se greška');
        });
    },
    loadItems({ callback, searchQuery }) {
      const handleSearch = debounce(() => {
        const id = this.mainForm.discountApplianceType;

        // Id = 2
        let actionName = 'getArticles';
        if (id === 3) actionName = 'getCategories';
        if (id === 4) actionName = 'getBrands';

        this.$store
        .dispatch(actionName, {
          isSortAscending: true,
          retrieveAll: true,
          quickSearch: searchQuery,
          sortBy: "createdDate",
        })
        .then(() => {
          callback(null, this.items);
        });
      }, 3000);
      handleSearch();
    },
    submitModalForm() {
      this.$v.newPromoCodeFrom.$touch();
      if (!this.isModalFormValid) {
        this.$toast.error(this.translations.forms.notValid);
        return;
      }
      const {
        title,
        businessType,
        discountApplianceType,
      } = this.newPromoCodeFrom;

      this.mainForm.title = title;
      this.mainForm.businessType = businessType;
      this.mainForm.discountApplianceType = discountApplianceType;

      $('#add-promo-code-modal').modal('hide');
    },
    openAddModal() {
      $('#add-promo-code-modal').modal('show');
    },
    cancelPromoCode() {
      this.$router.push({ name: "Coupons" });
    },
    addArticle(article) {
      const { id, vpc, title, code, mpc } = article;

      const parsedArticle = {
        articleId: id,
        code,
        mpc,
        title,
        vpc,
      };

      const foundArticle = this.promoCode.articles.find(
        (item) => item.articleId === article.id
      );

      this.showSearchResults = false;
      this.searchField = '';

      if (foundArticle) {
        this.$toast.error('Artikal je već dodan.');
        return;
      }
      this.promoCode.articles.push(parsedArticle);
    },
    addCategory(category) {
      const { id, title } = category;

      const parsedCategory = {
        categoryId: id,
        title,
      };

      const foundCategory = this.promoCode.categories.find(
        (item) => item.categoryId === category.id
      );

      this.showSearchResults = false;
      this.searchField = '';

      if (foundCategory) {
        this.$toast.error('Kategorija je već dodata.');
        return;
      }
      this.promoCode.categories.push(parsedCategory);
    },
    addBrand(brand) {
      const { id, title } = brand;

      const parsedBrand = {
        brandId: id,
        title,
      };

      const foundBrand = this.promoCode.brands.find(
        (item) => item.brandId === brand.id
      );

      this.showSearchResults = false;
      this.searchField = '';

      if (foundBrand) {
        this.$toast.error('Brend je već dodat.');
        return;
      }
      this.promoCode.brands.push(parsedBrand);
    },
    onSearchHandle: debounce(function (actionName) {
      this.showSearchResults = true;
      this.$store.dispatch(actionName, {
        sortBy: 'title',
        isSortAscending: true,
        page: 1,
        retrieveAll: true,
        quickSearch: this.searchField.trim(),
      });
    }, 300),
    onBlurHandle: debounce(function () {
    }, 300),
    deleteArticle(article) {
      const index = this.promoCode.articles.findIndex(
        (item) => item.articleId === article.articleId
      );
      this.promoCode.articles.splice(index, 1);
    },
    deleteCategory(category) {
      const index = this.promoCode.categories.findIndex(
        (item) => item.categoryId === category.categoryId
      );
      this.promoCode.categories.splice(index, 1);
    },
    deleteBrand(brand) {
      const index = this.promoCode.brands.findIndex(
        (item) => item.brandId === brand.brandId
      );
      this.promoCode.brands.splice(index, 1);
    },
  },
};
</script>

<style lang="scss" scoped>

.date-picker-width {
  width: 100%;
}

.position-relative {
  position: relative;
}

.article-list {
  position: absolute;
  margin-top: 3px;
  border: 1px solid #ced4da;
  border-radius: 0.25rem;
  list-style: none;
  padding: 0;
  z-index: 1;
  left: 12px;
  right: 12px;
  top: 40px;
  overflow-y: auto;
  max-height: 200px;

  li {
    display: block;
    border-top: 1px solid #ced4da;
    padding: 0 10px;
    cursor: pointer;
    overflow: hidden;

    &:first-child {
      border-top: none;
    }
  }
}

.card-articles {
  margin-bottom: 100px;
}

.custom-vue-tree-select .vue-treeselect__control {
  border: 1px solid #e7e7e7;
}

</style>